import "./Contact.scss";
import slide4 from 'Website/assets/images/slide4.png';
import { useTranslation } from "react-i18next";
const Contact = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="banner_section right">
                <div>
                    <div className="banner_image_content">
                        <div>
                            <h1 className="title">{t('pages.contactUs.title')}</h1>
                            <p>{t('pages.contactUs.desc')}</p>
                            <div className='contact_box'>
                                <div>
                                    <h5>{t('genericContent.email')}</h5>
                                    {/* <span>{process.env.REACT_APP_CONTACT_MAILID}</span> */}
                                    <span>info@jua.im</span>
                                    {/* <span>info@jua.im</span> */}
                                </div>
                                <div>
                                    <h5>{t('genericContent.phoneNumber')}</h5>
                                    {/* <span>{process.env.REACT_APP_CONTACT_NUMBER}</span> */}
                                    <span>(+44) 7575810392</span>
                                </div>
                                {/* <div>
                                    <h5>{t('genericContent.mailingAddress')}</h5>
                                    <span>DazWay LLC 1234</span>
                                    <span>Jakarta -Indonesia</span>
                                </div> */}
                            </div>
                            <div className='contact_box address-sec'>
                                <div>
                                    <h5>Mailing Address</h5>
                                    <span>DazWay Pay</span>
                                    <span>7 Bell Yard, London, England, WC2A 2JR</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <picture>
                        <img src={slide4} alt='Contact Us' title='Contact Us' className="lazy-img" />
                    </picture>
                </div>
            </section>
        </>
    )
}

export default Contact;